export interface StyleProps {
    /** Sets inline style for the element. */
    style?: React.CSSProperties;
    /** Sets the CSS className for the element. */
    className?: string;
}
